<template>
  <section class="grid-container intro_mdd">
    <!--    Enable spinner when needed: -->
    <FullScreenSpinner v-if="loading" />
    <Steps />
  </section>
</template>

<script>
import FullScreenSpinner from './components/FullScreenSpinner';
import Steps from './components/Steps/Steps';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'App',
  computed: {
    ...mapState(['loading']),
  },
  components: { Steps, FullScreenSpinner },
  mounted() {
    this.loadInitialState();
  },
  methods: {
    ...mapMutations(['loadInitialState']),
  },
};
</script>

<style lang="scss">
@import 'node_modules/normalize-scss/sass/normalize';

@include normalize();
@media all and (-ms-high-contrast: none) {
  h1.CardTitle p {
    background: none !important;
    color: #f8af10 !important;
  }
}

select,
option,
input,
textarea {
  outline: none;
}

@font-face {
  font-family: 'Nunito';
  font-style: normal;
  font-weight: 400;
  src: url('./assets/fonts/nunito-v9-latin-regular.eot'); /* IE9 Compat Modes */
  src: local('Nunito Regular'), local('Nunito-Regular'),
    url('./assets/fonts/nunito-v9-latin-regular.eot?#iefix')
      format('embedded-opentype'),
    url('./assets/fonts/nunito-v9-latin-regular.woff2') format('woff2'),
    url('./assets/fonts/nunito-v9-latin-regular.woff') format('woff'),
    url('./assets/fonts/nunito-v9-latin-regular.ttf') format('truetype'),
    url('./assets/fonts/nunito-v9-latin-regular.svg#Nunito') format('svg'); /* Legacy iOS */
}

body {
  * {
    box-sizing: border-box;
    font-family: 'Nunito', Helvetica, Roboto, Arial, sans-serif;
  }
  overflow-x: hidden;
  padding: 0;
  font-family: 'Nunito', Helvetica, Roboto, Arial, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.4;
  color: #0a0a0a;
  margin: 0;
  max-width: 100vw !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  //dev:
  background-color: #8b8b8b;

  @media print, screen and (max-width: 400px) {
    font-size: 15px;
  }

  a {
    color: black;
    transition: color 500ms ease-in;

    &:hover {
      color: #8b8b8b;
      transition: color 200ms ease-in;
    }
  }
}

*:focus {
  outline: none;
}

.grid-container {
  position: relative;
  padding: 49px 0.625rem 25px;
  // max-width: 960px;
  margin: 0 auto;
  background-color: white;

  @media print, screen and (min-width: 400px) {
    padding-right: 0.9375rem;
    padding-left: 0.9375rem;
  }
  @media print, screen and (max-width: 400px) {
    padding-top: 15px;
  }
}
.intro_mdd {
  text-align: center;
  overflow: hidden;
}

.em_hide {
  @media print, screen and (max-width: 400px) {
    display: none !important;
  }
}

.bold_mdd {
  font-weight: bolder !important;
}

.underline_mdd {
  text-decoration: underline !important;
}

.italic_mdd {
  font-style: italic;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Opera and Firefox */
}
</style>
